module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"delete":"Löschen"},"en":{"delete":"Delete"}}')
  delete Component.options._Ctor
}
